'use client';

import { useEffect, useMemo } from 'react';
import { useData } from '../../storage/accessors';
import useActualWheelId from '../../hooks/useActualWheelId';
import { createWheelSnapshot } from './wheelSnapshotUtils';
import { useReadonly } from '../../contexts/readonlyContext';

/**
 * Компонент, который автоматически сохраняет снимки колеса баланса
 * При любом изменении частей жизни
 * В режиме READONLY не записывает снепшоты.
 */
export default function WheelSnapshotObserver() {
    const wheelId = useActualWheelId();
    const { roles, wheelSnapshots } = useData();
    const { readonly } = useReadonly();

    // Генерируем UUID при каждом изменении roles.objects
    const lifePartsSignature = useMemo(() => crypto.randomUUID(), [roles.objects]);

    useEffect(() => {
        if (readonly) return;

        const lifePartsArray = Object.values(roles.objects);

        // Не сохраняем, если нет данных
        if (lifePartsArray.length === 0) return;

        // Создаём или обновляем снимок с новыми данными
        const today = new Date().toISOString().split('T')[0];
        const todaySnapshots = Object.values(wheelSnapshots.objects)
            .filter(s => s.wheelId === wheelId && s.date === today);

        const snapshot = createWheelSnapshot(wheelId, lifePartsArray);

        if (todaySnapshots.length > 0) {
            // Обновляем существующий снимок
            wheelSnapshots.save(todaySnapshots[0].uuid, {
                lifeParts: snapshot.lifeParts,
            });
            console.log(`Wheel snapshot updated for ${wheelId}:`, todaySnapshots[0].uuid);
        } else {
            // Создаём новый снимок
            wheelSnapshots.create(snapshot);
            console.log(`Wheel snapshot created for ${wheelId}:`, snapshot.uuid, snapshot.date);
        }
    }, [lifePartsSignature, wheelId, readonly]);

    return null;
}
